<template>
  <v-main>

    <v-container
        id="view-invoices-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-text-box-outline"
          class="px-5 py-3"
      >

        <div data-cy="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>

        <v-card-text v-if="invoices">

          <v-simple-table
              fixed-header
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="invoice-num text-subtitle-2">Inv #</th>
                <th class="invoice-details text-subtitle-2">Replenishment/Details</th>
                <th class="invoice-amount text-subtitle-2 text-right">Amount</th>
                <th class="invoice-balance text-subtitle-2 text-right">Balance</th>
                <th class="invoice-date text-subtitle-2">Inv. Date</th>
                <th class="due-date text-subtitle-2">Due Date</th>
                <th class="invoice-status text-subtitle-2">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="invoice in invoices"
                  :key="invoice.id"
              >
                <td>
                  <router-link :to="{ name: 'view_invoice', params: {id: invoice.id} }">
                    {{ invoice.id }}
                  </router-link>
                </td>
                <td>
                  <span v-if="invoice.items.length">
                    {{ invoice.items[0].description }}
                  </span>
                  <span v-else>
                    Other
                  </span>
                </td>
                <td class="text-right">{{ invoice.total | formatCurrency }}</td>
                <td class="text-right">{{ invoice.balance | formatCurrency }}</td>
                <td>{{ invoice.invoiceDate | formatLocalDate }}</td>
                <td>{{ invoice.dueDate | formatLocalDate }}</td>
                <td>{{ invoiceStatusMap[invoice.status] }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>

      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import constants from '@/utils/constants'
import {mapGetters} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: 'CoreViewInvoicesView',
  components: {SharedPageMessages},

  async created() {
    this.$gtag.event('view_invoices')

    this.userId = this.getUserId
    await this.fetchInvoices()
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    })
  },

  methods: {
    async fetchInvoices() {
      await api
          .fetchInvoices(this.userId)
          .then(response => {
            this.invoices = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      user: {
        country: 'US',
        idType: {}
      },
      invoices: [],
      invoiceStatusMap: constants.getInvoiceStatusMap()
    }
  }
}
</script>

<style lang="sass">
th.invoice-amount, th.invoice-status, th.invoice-balance
  width: 5%
th.invoice-num
  width: 8%

th.invoice-date, th.due-date, th.invoice-status
  width: 12%

</style>
